export default __webpack_public_path__ + "src/static/img/png/v2/about-us/pillar-2.png";